import { ActionsObservable, StateObservable, ofType } from 'redux-observable';
import {
  catchError, map, mergeMap, withLatestFrom,
} from 'rxjs/operators';

import serializeClub from '../../utils/serializers/serializeClub';
import { CLUBS_PATH } from '../../constants/paths';
import { Club, ClubDataResponse } from '../../models/Club';
import { FETCH_CLUB_LOGO_ERROR, FETCH_CLUB_LOGO_REQUEST } from '../../constants/actionTypes';
import { FetchClubLogoRequestAction } from '../../models/actions';
import { Response } from '../../models/Response';
import { State } from '../../models/State';
import { fetchClubLogoError, fetchClubLogoSuccess } from '../../actions/clubs';
import { handleError } from '../../actions/errors';

export default (
  action$: ActionsObservable<FetchClubLogoRequestAction>,
  state$: StateObservable<State>,
  { ajax }: any,
) => action$.pipe(
  ofType(FETCH_CLUB_LOGO_REQUEST),
  withLatestFrom(state$),
  mergeMap(([{ payload }, { authentication: { authToken }, application: { clubId } }]) => ajax({
    url: `${CLUBS_PATH}/${payload.clubId || clubId}/public`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authToken,
    },
  }).pipe(
    map(({ response: club }: Response<ClubDataResponse>) => serializeClub({ club })),
    map((club: Club) => fetchClubLogoSuccess(club)),
    catchError(error => [
      handleError(error, FETCH_CLUB_LOGO_ERROR),
      fetchClubLogoError(error),
    ]),
  )),
);
